<template>
  <section class="title-section">
    <div class="content-max-width">
      <h1>{{ title }}</h1>
      <div v-if="hasHtml" class="wysiwyg" v-html="content"></div>
      <p v-else>{{ content }}</p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    content: String,
    hasHtml: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../sass/core/variables.scss';

.title-section {
  padding: 26px 0 60px;
  border-bottom: 2px solid #e5e5e5;

  @media (max-width: $smallish) {
    padding: 30px 0;
  }

  .content-max-width {
    > *:last-child {
      margin-bottom: 0 !important;
    }
  }

  h1 {
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 0.2px;
    line-height: 42px;

    color: #404042;
  }

  p {
    max-width: 770px;
    width: 100%;
    margin: 0;

    font-size: 16px;
    letter-spacing: 0.6px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PageTitle.vue